import { RegistroCliente } from '../../../models/cliente/registro-cliente.class';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { RegistroClienteComponent } from '../registro-cliente/registro-cliente.component';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { Ciudad } from '../../../models/tipo/ciudad.class';
import { TipoDocumento } from '../../../models/tipo/tipo-documento.class';
import { RedireccionService } from '../../../services/redireccion/redireccion.service';
import { Ocupacion } from '../../../models/tipo/ocupacion.class';
import {
  AfterContentInit,
  OnDestroy,
} from '@angular/core/src/metadata/lifecycle_hooks';
import * as msg from '../../../../assets/msg/message.json';
import * as validaciones from '../../../../assets/validaciones/formulario-cliente.json';

import { ValidacionCliente } from '../../../models/cliente/validacion-cliente.class';
import { FiltroBuscarCliente } from '../../../models/filtro/filtro-buscar-cliente';
import { FiltroCliente } from '../../../models/filtro/filtro-cliente';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';
import { ClienteDireccionService } from '../../../services/cliente-direccion/cliente-direccion.service';
import { ConstantesFormularioCliente } from '../registro-cliente/constantes-formulario-clientes';
import { Cliente } from '../../../models/cliente/cliente.class';
import { DireccionCliente } from '../../../models/cliente/direccion-cliente.class';
import * as moment from 'moment';
import { AgenteService } from '../../../services/agente/agente.service';
import { TipoDireccion } from '../../../models/tipo/tipo-direccion.class';

@Component({
  selector: 'app-contenedor-cliente',
  templateUrl: './contenedor-cliente.component.html',
  styleUrls: ['./contenedor-cliente.component.scss'],
})

/**
 * TECYMDV-1895 / dacordero@personalsoft.com.co / 2021-07-02 / Obligatoriedad de campos pantalla clientes por producto
 */
export class ContenedorClienteComponent
  implements OnInit, OnDestroy, AfterContentInit {
  private static readonly PRODUCTO_DEFAULT = 'Default';

  vistaInicializada = false;
  productoSeleccionado;
  public subscriptionCliente: Subscription;
  public subscriptionProspecto: Subscription;

  public subscriptionDir1: Subscription;

  constantesFormularioCliente: ConstantesFormularioCliente =
    new ConstantesFormularioCliente();

  formCliente: FormGroup;
  formProspecto: FormGroup;

  /**
   * Flags que indican cuando un formulario hijo tiene errores
   */
  erroresFormCliente = false;
  erroresFormProspecto = false;
  erroresFormDir1 = false;
  erroresFormDir2 = false;
  erroresFormDir3 = false;

  registroClientePojo: RegistroCliente;
  registroProspectoPojo: RegistroCliente;

  @ViewChild('registroCliente')
  viewChildRegistroCliente: RegistroClienteComponent;
  @ViewChild('registroProspecto')
  viewChildRegistroProspecto: RegistroClienteComponent;

  // Usadas en el template: para hijos
  listCiudades: Ciudad[] = [];
  listTipoDocumentos: TipoDocumento[];
  listTipoActividad: Ocupacion[];
  muestraProspecto = false;

  validacionProducto: ValidacionCliente;
  clicKContinuar: boolean;

  // Usadas en el template: para esta
  mostrarMensajeError = false;
  mensajeError: String[] = [];

  private listValidaciones: ValidacionCliente[] = <any>validaciones;
  private navigationSubscription;

  private filtroBuscarCliente: FiltroBuscarCliente = null;

  private cargasIniciales: number;

  constructor(
    private clienteService: ClienteService,
    private redireccion: RedireccionService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private clienteDireccionService: ClienteDireccionService,
    private agenteService: AgenteService,
    private cdRef: ChangeDetectorRef
  ) {
    this.formCliente = this.formBuilder.group({});
    this.formProspecto = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.vistaInicializada = false;

    this.escucharErroresForms();

    // Cargar legacy
    this.cargarFiltroDocumento();

    this.obtenerProductoSeleccionado();

    this.execOnInit();
  }

  execOnInit() {
    this.validacionProducto = { asignacionCampos: [] } as ValidacionCliente;

    this.cargarFiltroDocumento();
    this.limpiarMensasError();

    // Cargas asíncronas
    this.cargasIniciales = 4;
    this.cargarListaDocumentos().then(() => this.intentarFinOnInit());
    this.cargarOcupaciones().then(() => this.intentarFinOnInit());
    this.consultarCiudad().then(() => this.intentarFinOnInit());

    this.consultarCliente().then(() => this.intentarFinOnInit());
  }

  intentarFinOnInit() {
    this.cargasIniciales--;

    if (this.cargasIniciales === 0) {
      this.validacionProducto = this.obtenerProductoSeleccionado();

      this.vistaInicializada = true;
    }
  }

  cargarFiltroDocumento() {
    this.filtroBuscarCliente = this.clienteService.getfiltroBuscarCliente();
  }

  obtenerProductoSeleccionado(): ValidacionCliente {
    let producto = null;
    const redireccionMenu = this.redireccion.getRedireccionMenu();
    if (
      redireccionMenu &&
      this.listValidaciones &&
      this.listValidaciones.length > 0
    ) {
      producto = this.listValidaciones.find(
        (x) => x.codigoProducto === redireccionMenu.contextPath
      );

      if (!producto) {
        producto = this.cargarProductoDefault();
      }
    }

    this.productoSeleccionado = producto.codigoProducto;

    return producto;
  }

  cargarProductoDefault() {
    return this.listValidaciones.find(
      (x) => x.codigoProducto === ContenedorClienteComponent.PRODUCTO_DEFAULT
    );
  }

  refrescarCliente(filtroCliente: FiltroCliente) {
    if (!this.filtroBuscarCliente) {
      this.filtroBuscarCliente = new FiltroBuscarCliente(
        filtroCliente,
        this.agenteService.getFiltroAgente()
      );
    } else {
      this.filtroBuscarCliente.datosCliente = filtroCliente;
    }

    setTimeout(() => {
      this.ngOnInit();
    }, 200);
  }

  consultarCliente() {
    let filtro = this.filtroBuscarCliente;
    filtro.datosAgente.perfil = this.agenteService.getPerfil();
    return this.clienteService
      .consultarCliente(filtro)
      .then((data) => {
        this.muestraProspecto = false;

        let incluyeCliente = false;
        let incluyeProspecto = false;
        this.registroClientePojo = new RegistroCliente();
        this.registroProspectoPojo = new RegistroCliente();

        // Es un cliente?
        if (data && data.cliente && Object.keys(data.cliente).length > 0) {
          incluyeCliente = true;
        }

        // Es un prospecto?
        if (data && data.prospecto && Object.keys(data.prospecto).length > 0) {
          incluyeProspecto = true;
        }

        if (incluyeCliente) {
          const copiaCliente = JSON.parse(JSON.stringify(data.cliente));

          this.registroClientePojo =
            this.cargarInformacionCliente(copiaCliente);
        }

        if (incluyeProspecto) {
          this.muestraProspecto = true;

          const copiaProspecto = JSON.parse(JSON.stringify(data.prospecto));

          this.registroProspectoPojo =
            this.cargarInformacionCliente(copiaProspecto);
        }

        // Es un caso "desconocido"?
        if (!incluyeCliente && !incluyeProspecto) {
          this.viewChildRegistroCliente.cargarInformacionFiltro(
            this.filtroBuscarCliente
          );
        }
      })
      .catch((error) => {
        console.error(
          'Usuario no encontrado con el filtro especificado. Error:',
          error
        );

        this.muestraProspecto = false;

        this.registroClientePojo = new RegistroCliente();
        (this.registroClientePojo.tipoIdentificacion =
          this.filtroBuscarCliente.datosCliente.tipoDocumento),
          (this.registroClientePojo.numeroIdentificacion =
            this.filtroBuscarCliente.datosCliente.numeroDocumento);

        this.registroProspectoPojo = new RegistroCliente();

        this.viewChildRegistroCliente.cargarInformacionFiltro(
          this.filtroBuscarCliente
        );

        // this.validacionProducto = this.obtenerProductoSeleccionado();
        // this.cdRef.detectChanges();

        this.validacionProducto = new ValidacionCliente();
        this.validacionProducto.asignacionCampos = [];
        this.cdRef.detectChanges();

        setTimeout(() => {
          this.validacionProducto = this.obtenerProductoSeleccionado();
          this.cdRef.detectChanges();
        }, 1500);
      });
  }

  cargarInfoGeneralCliente(informacionCliente: Cliente): RegistroCliente {
    const ret = new RegistroCliente();

    ret.tipoIdentificacion = informacionCliente.identificacion.tipo;
    ret.numeroIdentificacion = informacionCliente.identificacion.numero;

    ret.nombre1 = informacionCliente.datosPersonales.primerNombre;
    ret.nombre2 = informacionCliente.datosPersonales.segundoNombre;
    ret.apellido1 = informacionCliente.datosPersonales.primerApellido;
    ret.apellido2 = informacionCliente.datosPersonales.segundoApellido;
    ret.sexo = informacionCliente.datosPersonales.sexo;

    if (
      informacionCliente.datosPersonales &&
      informacionCliente.datosPersonales.fechaNacimiento
    ) {
      let posibleFecha: any;

      try {
        // posibleFecha = moment(

        const asd = moment(informacionCliente.datosPersonales.fechaNacimiento);

        if (asd.isValid()) {
          posibleFecha = asd.toDate();
        }
      } catch (e) {
        console.warn('Primer formato de fecha no aceptado');
      }

      if (!posibleFecha) {
        posibleFecha = moment(
          Number(informacionCliente.datosPersonales.fechaNacimiento)
        ).toDate();
      }

      ret.fechaNacimiento = posibleFecha;
    } else {
      ret.fechaNacimiento = null;
    }

    // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (
      informacionCliente.identificacion &&
      informacionCliente.identificacion.fechaExpedicion
    ) {
      let posibleFecha: any;

      try {

        const asd = moment(informacionCliente.identificacion.fechaExpedicion);

        if (asd.isValid()) {
          posibleFecha = asd.toDate();
        }
      } catch (e) {
        console.warn('Primer formato de fecha de expedición no aceptado');
      }

      if (!posibleFecha) {
        posibleFecha = moment(
          Number(informacionCliente.identificacion.fechaExpedicion)
        ).toDate();
      }

      ret.fechaExpedicion = posibleFecha;
    } else {
      ret.fechaExpedicion = null;
    }


    ret.celular = informacionCliente.datosPersonales.numeroCelular;
    ret.tipoPersona = informacionCliente.identificacion.tipoPersona;
    ret.ocupacion = informacionCliente.datosPersonales.ocupacion;


    // dacordero@personalsoft.com.co - 2021/08/20 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (
      informacionCliente.datosPersonales &&
      informacionCliente.datosPersonales.paisOrigen
    ) {
      ret.paisOrigen = informacionCliente.datosPersonales.paisOrigen;
    } else {
      ret.paisOrigen = null;
    }


    ret.direcciones = this.cargarInfoDireccionesCliente(informacionCliente);

    return ret;
  }

  cargarInfoDireccionesCliente(informacionCliente: Cliente): {
    [nombre: string]: DireccionCliente;
  } {
    const ret = {};

    informacionCliente.direcciones.forEach((direccion) => {
      switch (direccion.tipoDireccion) {
        case TipoDireccion.TIPO_DIRECCION_TRABAJO.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_TRABAJO.id}`] = direccion;

          break;
        }
        case TipoDireccion.TIPO_DIRECCION_RESIDENCIA.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_RESIDENCIA.id}`] = direccion;

          break;
        }
        case TipoDireccion.TIPO_DIRECCION_OTRO.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_OTRO.id}`] = direccion;

          break;
        }
        case TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_OFICINA_PRINCIPAL.id}`] =
            direccion;

          break;
        }
        case TipoDireccion.TIPO_DIRECCION_REP_LEGAL.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_REP_LEGAL.id}`] = direccion;

          break;
        }
        case TipoDireccion.TIPO_DIRECCION_SURCURSAL.id: {
          ret[`${TipoDireccion.TIPO_DIRECCION_SURCURSAL.id}`] = direccion;

          break;
        }
      }
    });

    return ret;
  }

  cargarInformacionCliente(cliente: any) {
    return this.cargarInfoGeneralCliente(cliente);
  }

  copiarTodaInformacionProspecto() {
    this.clienteDireccionService.setTraspasarTodosCamposProspecto(true);
  }

  async consultarCiudad() {
    return this.clienteService
      .getListCiudad()
      .then((lasCiud) => {
        this.listCiudades = lasCiud;
      })
      .catch((err) => console.error('Error', err));
  }

  async cargarListaDocumentos() {
    return this.clienteService
      .getListTipoDocumento(
        this.redireccion.obtenerCodigoPaisPorTipoRedireccion(),
        this.redireccion.obtenerCodigoGrupoPersonaPorTipoRedireccion()
      )
      .then((resp) => {
        this.listTipoDocumentos =
          this.clienteService.getTiposDocumentosXCliente(
            this.redireccion.getRedireccionMenu().tipoDocumento,
            resp
          );
      })
      .catch((err) => console.error(err));
  }

  async cargarOcupaciones() {
    return this.clienteService
      .getOcupaciones()
      .then((listaOcup) => {
        this.listTipoActividad = listaOcup;
      })
      .catch((err) => console.error('Error:', err));
  }

  mensajeAlerta(mensaje) {
    window.scroll(0, 0);
    this.limpiarMensasError();
    this.addMensaje(true, mensaje);
  }

  continuar() {
    this.viewChildRegistroCliente.clicKContinuar = true;
      if (this.viewChildRegistroCliente.validarDireccionNecesaria()) {
        this.registrarProspecto();
      } else {
        this.mensajeAlerta((<any>msg).msgRegistroCliente.direccionNecesaria);
      }
  }

  registrarProspecto() {

    this.clicKContinuar = true;

    const registroProsp =
      this.viewChildRegistroCliente.obtenerRegistroProspecto();

    const objetoParaEnviar = JSON.parse(
      JSON.stringify(registroProsp)
    );

    if (!objetoParaEnviar.datosPersonales) {
      objetoParaEnviar.datosPersonales = {};
    }
    objetoParaEnviar.datosPersonales.identificacion =
      this.viewChildRegistroCliente.cargarIdentificacionProspecto();

    // Opcionalizar el guardado de los campos según la visibilidad

    const objetoEnviarzz = this.prepararCliente2(objetoParaEnviar);

    const tt = this.viewChildRegistroCliente.prepararObjetoParaEnviar2(objetoEnviarzz);

    tt.identificacion = objetoParaEnviar.datosPersonales.identificacion;

    objetoParaEnviar.datosPersonales = tt;

    return (
      this.clienteService

        .guardarClienteProspecto(objetoParaEnviar)

        .then((success) => {
          this.clicKContinuar = false;
          this.enviarInformacionSuraCliente();
        })
        .catch((error) => {
          this.clicKContinuar = false;

          if (error && Array.isArray(error) && error[0].mensaje) {
            window.scroll(0, 0);
            this.mensajeError.length = 0;
            error.forEach((mensajeItem) => {
              this.addMensaje(false, mensajeItem.mensaje);
            });
          } else {
            this.notificarErrorGuardar();
          }
        })
    );
  }

  prepararCliente2(ope: any) {
    const objetoParaEnviar: any = {};

    if (ope.datosPersonales) {
      if (ope.datosPersonales.primerNombre) {
        objetoParaEnviar.primerNombre = ope.datosPersonales.primerNombre;
      }

      if (ope.datosPersonales.segundoNombre) {
        objetoParaEnviar.segundoNombre = ope.datosPersonales.segundoNombre;
      }

      if (ope.datosPersonales.primerApellido) {
        objetoParaEnviar.primerApellido = ope.datosPersonales.primerApellido;
      }

      if (ope.datosPersonales.segundoApellido) {
        objetoParaEnviar.segundoApellido = ope.datosPersonales.segundoApellido;
      }

      if (ope.datosPersonales.fechaNacimiento) {
        objetoParaEnviar.fechaNacimiento = moment(
          ope.datosPersonales.fechaNacimiento
        )
          .toDate()
          .getTime();
      }

      if (ope.datosPersonales.sexo) {
        objetoParaEnviar.sexo = ope.datosPersonales.sexo;
      }

      if (ope.datosPersonales.numeroCelular) {
        objetoParaEnviar.celular = ope.datosPersonales.numeroCelular;
      }

      if (ope.datosPersonales.ocupacion) {
        objetoParaEnviar.ocupacion = {
          "id": ope.datosPersonales.ocupacion.id,
          "descripcionOcupacion":ope.datosPersonales.ocupacion.descripcion
         }
      }

      const lasDirecciones = ope.datosPersonales.direcciones;

      if (lasDirecciones && lasDirecciones.length > 0) {
        objetoParaEnviar.direcciones = lasDirecciones;
      }
    }

    return objetoParaEnviar;
  }

  redireccionarProducto() {
    this.redireccion.redireccionProducto(
      this.registroClientePojo.tipoIdentificacion
        .concat(this.registroClientePojo.numeroIdentificacion.toString())
        .toString()
    );
  }

  addMensaje(limpiar: boolean, mensaje: String) {
    this.mostrarMensajeError = true;
    if (limpiar) {
      this.mensajeError.length = 0;
    }
    this.mensajeError.push(mensaje);
  }

  notificarErrorGuardar() {
    window.scroll(0, 0);
    this.limpiarMensasError();
    this.addMensaje(true, (<any>msg).msgRegistroCliente.errorGuardandoCliente);
  }

  limpiarMensasError() {
    this.mensajeError.length = 0;
    this.mostrarMensajeError = false;
  }

  ngOnDestroy(): void {
    if (!this.subscriptionCliente.closed) {
      this.subscriptionCliente.unsubscribe();
    }
    if (!this.subscriptionProspecto.closed) {
      this.subscriptionProspecto.unsubscribe();
    }
    if (!this.subscriptionDir1.closed) {
      this.subscriptionDir1.unsubscribe();
    }

    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    this.clienteService.setProductoSeleccionado(null);
    this.clienteService.setfiltroBuscarCliente(null);
    this.redireccion.setRedireccionMenu(null);
  }

  // Guardar la info del cliente
  enviarInformacionSuraCliente() {

    const objetoEnviar = this.prepararCliente();

    return (
      this.clienteService
        .guardarCliente(objetoEnviar)
        .then((success) => {
          this.redireccionarProducto();
        })
        .catch((error) => {
          this.redireccionarProducto();
        })
    );
  }

  prepararCliente() {
    const objetoParaEnviar: any = {};
    const objetoParaEnviar2 = JSON.parse(
      JSON.stringify(this.registroClientePojo)
    );

    // Enviar la info si es necesaria
    const lasDirecciones =
      this.viewChildRegistroCliente.obtenerDireccionesCliente();

    if (lasDirecciones && lasDirecciones.length > 0) {
      objetoParaEnviar.direcciones = lasDirecciones;
    }

    if (
      lasDirecciones &&
      lasDirecciones.length > 0 &&
      this.viewChildRegistroCliente.tipoCorreoElectornico
    ) {
      objetoParaEnviar.correspondenciaSeleccionada =
        this.viewChildRegistroCliente.tipoCorreoElectornico;
    }

    objetoParaEnviar.dniAsesor = this.agenteService.getFiltroAgente().codAsesor;

    let tt = this.viewChildRegistroCliente.obtenerRegistroProspecto();

    tt = this.viewChildRegistroCliente.prepararObjetoParaEnviar(tt);

    if (
      tt.datosPersonales &&
      tt.datosPersonales.direcciones &&
      tt.datosPersonales.direcciones.length > 0 &&
      this.viewChildRegistroCliente.tipoCorreoElectornico
    ) {
      objetoParaEnviar.correspondenciaSeleccionada =
        this.viewChildRegistroCliente.tipoCorreoElectornico;

      if (lasDirecciones.length < 1) {
        objetoParaEnviar.direcciones = tt.datosPersonales.direcciones;
      }
    }

    if (tt.datosPersonales) {
      if (tt.datosPersonales.primerNombre) {
        objetoParaEnviar.nombre1 = tt.datosPersonales.primerNombre;
      }

      if (tt.datosPersonales.segundoNombre) {
        objetoParaEnviar.nombre2 = tt.datosPersonales.segundoNombre;
      }

      if (tt.datosPersonales.primerApellido) {
        objetoParaEnviar.apellido1 = tt.datosPersonales.primerApellido;
      }

      if (tt.datosPersonales.segundoApellido) {
        objetoParaEnviar.apellido2 = tt.datosPersonales.segundoApellido;
      }

      if (tt.datosPersonales.numeroCelular) {
        objetoParaEnviar.celular = tt.datosPersonales.numeroCelular;
      }

      if (tt.datosPersonales.ocupacion) {
        objetoParaEnviar.descripcionOcupacion =
          tt.datosPersonales.ocupacion.descripcion;
        objetoParaEnviar.ocupacion = tt.datosPersonales.ocupacion.id;
      }

      if (tt.datosPersonales.fechaNacimiento) {
        objetoParaEnviar.fechaNacimiento =
          '' +
          moment(tt.datosPersonales.fechaNacimiento).toDate().toISOString();
      }

      if (tt.datosPersonales.sexo) {
        objetoParaEnviar.sexo = tt.datosPersonales.sexo;
      }


    }

    const unaIdentif =
      this.viewChildRegistroCliente.cargarIdentificacionProspecto();

    objetoParaEnviar.numeroIdentificacion = unaIdentif.numero;
    objetoParaEnviar.tipoIdentificacion = unaIdentif.tipo.id;
    objetoParaEnviar.tipoPersona = unaIdentif.tipo.tipoPersona;

    // dacordero@personalsoft.com.co - 2021/08/23 - Cambio de Santiago. Copiado y adaptado de feature/TSTAR-2001
    if (unaIdentif.fechaExpedicion) {
      const dateNum = Number(unaIdentif.fechaExpedicion);
      objetoParaEnviar.fechaExpedicion = moment(dateNum).toISOString();
    }

    const po = this.viewChildRegistroCliente.cliente.paisOrigen;
    if (po) {
      objetoParaEnviar.paisOrigen = po;
    }

    return objetoParaEnviar;
  }

  escucharErroresForms() {
    if (!this.subscriptionCliente || this.subscriptionCliente.closed) {
      this.subscriptionCliente = this.clienteDireccionService
        .getReporteErroresProspecto()
        .subscribe((hayErroresFormProspecto) => {
          this.erroresFormProspecto = hayErroresFormProspecto;
        });
    }

    if (!this.subscriptionProspecto || this.subscriptionProspecto.closed) {
      this.subscriptionProspecto = this.clienteDireccionService
        .getReporteErroresCliente()
        .subscribe((hayErroresFormCliente) => {
          this.erroresFormCliente = hayErroresFormCliente;
        });
    }

    if (!this.subscriptionDir1 || this.subscriptionDir1.closed) {
      this.subscriptionDir1 = this.clienteDireccionService
        .getReporteFormDireccion()
        .subscribe((hayErr) => {

          switch (hayErr.nombreForm) {
            case this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_1: {
              this.erroresFormDir1 = hayErr.invalido;
              break;
            }
            case this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_2: {
              this.erroresFormDir2 = hayErr.invalido;
              break;
            }
            case this.constantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION_3: {
              this.erroresFormDir3 = hayErr.invalido;
              break;
            }
          }
        });
    }
  }

  btnContinuarDisabled(): boolean {
    const desactiva =
      this.erroresFormCliente ||
      this.erroresFormProspecto ||
      this.erroresFormDir1 ||
      this.erroresFormDir2 ||
      this.erroresFormDir3;

    return desactiva;
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.clienteDireccionService.setRevalidarTodosFormularios(true);
    }, 5000);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cliente/contenedor-cliente/contenedor-cliente.component.ts